'use client'
import { Autocomplete, TextField } from '@mui/material'
import { AutoCompleteLabelOptionsMapping, FieldValue, LanguageCode } from '@/types'
import { useState } from 'react'
import Fuse from 'fuse.js'
import { AutoCompleteFieldLabel } from '@/enum'
import { HINDU_CASTE_OPTIONS } from '@/app/api/data/HinduCasteOptions'
import { EDUCATION_OPTIONS } from '@/app/api/data/EducationOption'
import { GOTHRA_OPTIONS } from '@/app/api/data/GothraOptions'
import { MOTHER_TONGUE_OPTIONS } from '@/app/api/data/MotherTongueOptions'
import { NAKSHATRA_OPTIONS } from '@/app/api/data/NakshatraOptions'
import { OCCUPATION_OPTIONS } from '@/app/api/data/OccupationOptions'
import { useLocale } from 'next-intl'
import { GAN_OPTIONS } from '@/app/api/data/GanOptions'
import { NADI_OPTIONS } from '@/app/api/data/NadiOptions'
import { MANGALIK_OPTIONS } from '@/app/api/data/MangalikOptions'

type AutoCompleteTextFieldProps = {
  id: string
  value: FieldValue
  onChangeHandler: (val: FieldValue, fieldId: string) => void
  placeholder?: string
  identifier: string
}

const fuseOptions = {
  isCaseSensitive: false,
  includeScore: false,
  shouldSort: true,
  minMatchCharLength: 2,
  threshold: 0.2,
  ignoreLocation: true,
}

const AutoCompleteLabelOptionsMap: AutoCompleteLabelOptionsMapping = {
  [AutoCompleteFieldLabel.CASTE]: HINDU_CASTE_OPTIONS,
  [AutoCompleteFieldLabel.EDUCATION]: EDUCATION_OPTIONS,
  [AutoCompleteFieldLabel.GOTHRA]: GOTHRA_OPTIONS,
  [AutoCompleteFieldLabel.MOTHER_TONGUE]: MOTHER_TONGUE_OPTIONS,
  [AutoCompleteFieldLabel.NAKSHATRA]: NAKSHATRA_OPTIONS,
  [AutoCompleteFieldLabel.OCCUPATION]: OCCUPATION_OPTIONS,
  [AutoCompleteFieldLabel.GAN]: GAN_OPTIONS,
  [AutoCompleteFieldLabel.NADI]: NADI_OPTIONS,
  [AutoCompleteFieldLabel.MANGALIK]: MANGALIK_OPTIONS,
}

const AutoCompleteTextField: React.FC<AutoCompleteTextFieldProps> = ({ id, value, onChangeHandler, placeholder, identifier }) => {
  const [autoCompleteOptions, setAutoCompleteOptions] = useState<string[]>([])
  const locale = useLocale()

  const fetchOptions = (query: string, identifier: AutoCompleteFieldLabel) => {
    if (!query.length || query.length < 2) {
      setAutoCompleteOptions([])
      return
    }
    if (AutoCompleteLabelOptionsMap[identifier] && AutoCompleteLabelOptionsMap[identifier][locale as LanguageCode]) {
      const fuse = new Fuse(AutoCompleteLabelOptionsMap[identifier][locale as LanguageCode], fuseOptions)
      const results = fuse.search(query).map((result) => result.item)
      setAutoCompleteOptions(results)
    } else {
      console.error('Invalid identifier or locale')
      setAutoCompleteOptions([])
    }
  }

  return (
    <Autocomplete
      freeSolo
      fullWidth
      disablePortal
      options={autoCompleteOptions}
      value={value as string}
      includeInputInList
      filterSelectedOptions
      getOptionLabel={(option) => (typeof option === 'string' ? option : '')}
      filterOptions={(x) => x}
      // onChange={(_, newValue: string | null) => {
      // console.log(newValue)
      // }}
      onInputChange={(_, newVal) => {
        onChangeHandler(newVal, id)
        fetchOptions(newVal, identifier as AutoCompleteFieldLabel)
      }}
      renderInput={(params) => (
        <TextField
          placeholder={placeholder}
          {...params}
          hiddenLabel
          size="small"
        />
      )}
    />
  )
}

export default AutoCompleteTextField
